<button class="container" [ngbTooltip]="tooltipSignatureVisible" container="body" (click)="goToCreditsPage()">
  @if (!disableIcon) {
    <i class="fas fa-shield-check"></i>
  }

  @if (user) {
    <div class="credits">
      <div class="credits__monthly">
        {{ totalCredits() > 999 ? '99+' : totalCredits() }}
      </div>
    </div>
  }
</button>

<ng-template #tooltipSignatureVisible>
  <div class="tooltip__descr">{{ 'shared.availableCreditsForAdditionalVerification' | translate: { credits: totalCredits() } }}</div>
</ng-template>
